module.exports = __webpack_public_path__ + "img/Villa_Borna_47.92c2ab6d.jpg";